import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import localeNL from '@angular/common/locales/nl';
import { Inject, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TitleStrategy } from '@angular/router';

import { ApAnalyticsService, ApPageviewDataService } from '@ap/analytics';
import { ApContentModule } from '@ap/content';
import { SessiebeheerModule } from '@ap/interface-apic-sessiebeheer';
import { ApKeepAliveComponent } from '@ap/keep-alive';
import { MijnAnalyseModule } from '@ap/mijn-analyse';
import { MijnErrorHandlerModule } from '@ap/mijn-error-handler';
import { MijnWebcomponentProviderName } from '@ap/mijn-navigatie';
import { MijnOmgevingTemplateModule } from '@ap/mijn-template';
import { MijnTitleStrategy } from '@ap/mijn-titlestrategy';
import { ApWebcomponentComponent, ApWebcomponentService } from '@ap/webcomponent';
import { provideMijnAuthSessieManager } from '@ap/mijn-auth-sessie-manager';
import { MijnWebpartMessagingModule, WebpartMessagingService } from '@ap/mijn-webpart-messaging';

import { HttpErrorInterceptor } from './interceptor/http-error/http-error.interceptor';
import { MijnErrorModule } from './mijn-error/mijn-error.module';
import { MijnOmgevingComponent } from './mijn-omgeving.component';
import { MijnOmgevingNavigation } from './mijn-omgeving.navigation';
import { MijnOmgevingRouterModule } from './mijn-omgeving.router.module';
import { MijnWebcomponentService } from './mijn-webcomponent.service';
import { MijnOmgevingWebpartMessagingService } from './webpart-messaging/webpart-messaging.service';
import { PhoneNumberValidationModule } from './phonenumber-validation/phonenumber-validation.module';
import { Auth0sessionModule } from './auth0session/auth0session.module';
/**
 * @name MijnOmgevingModule
 * @ngdoc module
 */
@NgModule({
    declarations: [MijnOmgevingComponent],
    exports: [MijnOmgevingComponent],
    bootstrap: [MijnOmgevingComponent],
    imports: [
        ApContentModule,
        ApKeepAliveComponent,
        ApWebcomponentComponent,
        BrowserAnimationsModule,
        MijnAnalyseModule,
        MijnErrorHandlerModule,
        MijnErrorModule,
        MijnOmgevingRouterModule,
        MijnOmgevingTemplateModule,
        MijnWebpartMessagingModule,
        SessiebeheerModule,
        PhoneNumberValidationModule,
        Auth0sessionModule
    ],
    providers: [
        provideMijnAuthSessieManager(),
        ApAnalyticsService,
        MijnOmgevingNavigation,
        ApPageviewDataService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        {
            provide: ApWebcomponentService,
            useClass: MijnWebcomponentService
        },
        {
            provide: TitleStrategy,
            useClass: MijnTitleStrategy
        },
        {
            provide: MijnWebcomponentProviderName,
            useValue: 'mijn-omgeving'
        },
        {
            provide: WebpartMessagingService,
            useClass: MijnOmgevingWebpartMessagingService
        }
    ]
})
export class MijnOmgevingModule {
    public constructor(@Inject(TitleStrategy) titleStrategy: MijnTitleStrategy) {
        registerLocaleData(localeNL, 'nl');
        titleStrategy.setDynamicTitles({});
    }
}
